import PropTypes from "prop-types";
import pillsPropType from "./propTypes/pills";
import styles from "./ChildLinks.css";
import { withTranslation } from "../translation";
import Pill from "./Pill";

const renderPills = pills =>
  pills.map(({ friendlyName, linkUrl }) => (
    <Pill
      key={friendlyName}
      linkUrl={linkUrl}
      friendlyName={friendlyName}
      extraClassName={styles.pill}
    />
  ));

export const ChildLinksComponent = ({
  pills,
  viewMoreButtonPosition,
  showViewMore,
  onViewMoreButtonSet,
  onViewMoreButtonClicked,
  formatTranslation,
  hasCategoryHeaderPills
}) => {
  const pillsBeforeViewMore = pills.slice(0, viewMoreButtonPosition);
  const pillsAfterViewMore = pills.slice(viewMoreButtonPosition);

  return (
    <div className={styles.container}>
      {!hasCategoryHeaderPills && <hr className={styles.separator} />}
      <ul data-auto-id="childLinksContainer">
        {renderPills(pillsBeforeViewMore)}
        {showViewMore ? (
          <li className={styles.viewMoreWrapper} ref={onViewMoreButtonSet}>
            <button
              onClick={onViewMoreButtonClicked}
              className={styles.viewMore}
            >
              {formatTranslation("plp_web_view_more_button_label")}...
            </button>
          </li>
        ) : null}
        {renderPills(pillsAfterViewMore)}
      </ul>
    </div>
  );
};

ChildLinksComponent.propTypes = {
  onViewMoreButtonSet: PropTypes.func,
  pills: pillsPropType.isRequired,
  showViewMore: PropTypes.bool,
  viewMoreButtonPosition: PropTypes.number,
  onViewMoreButtonClicked: PropTypes.func,
  hasCategoryHeaderPills: PropTypes.bool,
  formatTranslation: PropTypes.func.isRequired
};

ChildLinksComponent.defaultProps = {
  hasCategoryHeaderPills: false
};

export default withTranslation(ChildLinksComponent);
